import { FunctionComponent } from "react"
import BaseButton from "./Button/base-button"

type ProgressDialogBoxProps = {
  title: string
  text?: string
  children?: JSX.Element
  buttons: ButtonProps[]
}

type ButtonProps = {
  text: string
  callback: () => void
}

const ProgressDialogBox: FunctionComponent<ProgressDialogBoxProps> = ({
  title,
  text,
  children,
  buttons,
}) => {
  return (
    <div className="self-stretch overflow-hidden flex flex-row items-start justify-center gap-[32px]">
      <div className="self-stretch min-w-[625px] max-w-[50dvw] rounded-xl bg-base-white shadow-[0px_1px_3px_rgba(16,_24,_40,_0.1),_0px_1px_2px_rgba(16,_24,_40,_0.06)] overflow-hidden flex flex-col items-start justify-start py-6 mb-8 gap-[21px] text-primary-700 border-[1px] border-solid border-gray-200">
        <div className="flex flex-col overflow-hidden items-start justity-center mx-6 gap-4">
          <div className="self-stretch flex flex-col items-start justify-start z-[0]">
            <img
              className="relative rounded-3xl w-12 h-12"
              alt=""
              src="/v3/assets/featured_icon.svg"
            />
          </div>
          <div
            id="progressDialogScroller"
            className="self-stretch flex flex-row overflow-y-auto items-start justify-start pr-3">
            <div className="self-stretch flex flex-col items-start justify-start gap-[4px]">
              <div className="self-stretch relative leading-[28px] font-semibold text-lg">
                {title}
              </div>
              <div className="self-stretch relative text-sm leading-[24px] text-gray-600">
                {children || text}
              </div>
            </div>
          </div>
          <div className="self-stretch flex-shrink-0 gap-[12px]">
            <div className="self-stretch flex flex-row items-start justify-start gap-[12px]">
              {buttons.map((button, index) => (
                <BaseButton
                  key={index}
                  onClick={button.callback}
                  disabled={false}
                  variant="primary">
                  <div className="relative text-base font-text-md-semibold leading-[28px]">
                    {button.text}
                  </div>
                </BaseButton>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProgressDialogBox
